import { render, staticRenderFns } from "./Speechor.vue?vue&type=template&id=5d5d3b15&scoped=true&"
import script from "./Speechor.vue?vue&type=script&lang=js&"
export * from "./Speechor.vue?vue&type=script&lang=js&"
import style0 from "./Speechor.vue?vue&type=style&index=0&id=5d5d3b15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d3b15",
  null
  
)

export default component.exports